import {
    SET_SCROLL_PROGRESS,
    SET_SCROLL_HEIGHT,
    SET_FORM_SENT,
    SET_WINDOW_WIDTH,
    SET_WINDOW_HEIGHT
} from "../actionTypes";

const initialState = {
    scrollProgress: 0,
    scrollHeight: 0,
    formSent: null,
    windowWidth: window.innerWidth,
    windowHeight: document.documentElement.clientHeight,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_SCROLL_PROGRESS:
            return {
                ...state,
                scrollProgress: action.payload
            };
        case SET_SCROLL_HEIGHT:
            return {
                ...state,
                scrollHeight: action.payload
            };
        case SET_FORM_SENT:
            return {
                ...state,
                formSent: action.payload
            };
        case SET_WINDOW_WIDTH:
            return {
                ...state,
                windowWidth: action.payload ? action.payload : window.innerWidth
            };
        case SET_WINDOW_HEIGHT:
            return {
                ...state,
                windowHeight: action.payload ? action.payload : document.documentElement.clientHeight
            };
        default:
            return state;
    }
}
